import TableChartSidebar from 'components/Table/TableChartSidebar';
import { BatterReportChartConfigDto, TableChartConfigDto } from 'types/CodegenReportTypes';
import { ChartConfigProps } from 'utilities/chartIdToComponent';

const BattingStatsChartSidebar = (props: ChartConfigProps<TableChartConfigDto, BatterReportChartConfigDto>) => {
  return <TableChartSidebar chartId='BattingStatsChart' chartKey='battingStatsChartConfig' {...props} />;
};

export default BattingStatsChartSidebar;
